import LogoHeader from './../assets/images/icons/logo-header.png';
import LogoShort from './../assets/images/icons/logo-short.jpg';
import Documenticon from './../assets/images/icons/folder.png';
import ReqIcon from "./../assets/images/icons/req.png"

const IMAGES = {
    LogoHeader: LogoHeader,
    LogoShort: LogoShort,
    Documenticon: Documenticon,
    ReqIcon: ReqIcon,
}
export default IMAGES